import { c as _c } from "react/compiler-runtime";
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const ComingSoonBadge = () => {
  const $ = _c(4);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("global.coming_soon");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="border-1 border-brand-primary text-brand-primary bg-brand-primary/10 w-fit rounded-md px-2.5 py-1.5">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};